import React from 'react'

import { Window } from '../contexts/index.jsx'

const Address = ({ address, className = '' }) => {
    if (!address) {
        return null;
    }

    const country = Window.COUNTRIES.find((c) => c.id === address?.country_id)

    return (
        <div className={className}>
            {address?.first_name}  {address?.last_name}
            {address?.phone && ", " + address?.phone}
            <br/>
            {address?.line1} <br/>
            {address?.line2 && (<> {address?.line2} <br/> </>)}
            {address?.postal_code} {address?.locality} {address?.region && "(" + address?.region + ")"} <br/>
            {country?.name}
        </div>
    )
}

export default Address
